export const data = [
  {
    title:
      "The lean startup Lorem Ipsum Lorem Ipsum is simply dummy text of the printing",
    image:
      "https://m.media-amazon.com/images/S/mms-media-storage-prod/final/BrandPosts/brandPosts/3842c163-9795-498e-9b4a-58279ddab20e/3f86e7a3-2a77-4396-a8af-da8689463ae3/media._SL850_.jpeg",
    price: 12.99,
    rating: 4,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 1
  },
  {
    title: "Bedside Table Lamp, Aooshine Minimalist Solid Wood Table",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/61gZHE7ON-L._AC_SL1000_.jpg",
    price: 19.99,
    rating: 3,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 2
  },
  {
    title: "adidas Unisex Midvale Backpack, Black/White, ONE SIZE",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/81qZ%2Be2R%2BfL._AC_SL1500_.jpg",
    price: 99.99,
    rating: 4,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",

    id: 3
  },
  {
    title: "SAMSUNG 43-inch Class Crystal UHD TU-8000 Series - 4K UHD",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/71RiQZ0J2SL._AC_SL1000_.jpg",
    price: 899.99,
    rating: 5,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 4
  },

  {
    title:
      "HP OfficeJet Pro 8025 All-in-One Wireless Printer, Smart Home Office Productivity,",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/71RiQZ0J2SL._AC_SL1000_.jpg",
    price: 99.99,
    rating: 2,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 5
  },

  {
    title:
      "Roadmaster - 26 Inches Granite Peak Men's Mountain Bike, Black/Blue",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/61SUADlym1L._AC_SL1242_.jpg",
    price: 399.99,
    rating: 5,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 6
  },
  {
    title:
      "Anker USB C to Dual HDMI Adapter, Compact and Portable USB C Adapter, Supports 4K@60Hz ",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/61K0tE784FL._AC_SL1500_.jpg",
    price: 399.99,
    rating: 5,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 7
  },
  {
    title:
      "New Apple Watch Series 6 (GPS, 40mm) - Blue Aluminum Case with Deep Navy Sport Band",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/71bf9IpGjtL._AC_SL1500_.jpg",
    price: 399.99,
    rating: 5,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 8
  },
  {
    title:
      "New Apple iPhone SE (64GB, (Product) RED) [Locked] + Carrier Subscription",
    image: "https://m.media-amazon.com/images/I/810DvHOZ9nL._FMwebp__.jpg",
    price: 399.99,
    rating: 5,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 9
  },
  {
    title:
      "Canon PowerShot SX540 Digital Camera w/ 50x Optical Zoom - Wi-Fi & NFC Enabled (Black), 1 - 1067C001",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/81l6xdQOHyL._AC_SL1500_.jpg",
    price: 399.99,
    rating: 5,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 10
  },
  {
    title:
      "BM Skateboard Helmet Impact Resistance Ventilation for Multi-Sports Cycling Skateboarding Scooter Roller Skate Inline Skating Longboard",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/51QBbe8NE8L._AC_SL1000_.jpg",
    price: 399.99,
    rating: 5,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 11
  },
  {
    title:
      "The Art of Training Your Dog: How to Gently Teach Good Behavior Using an E-Collar",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/51FrVHuq1rL._SX218_BO1,204,203,200_QL40_FMwebp_.jpg",
    price: 399.99,
    rating: 5,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 12
  },
  {
    title:
      "Apple MacBook Pro MD101LL/A 13.3-inch Laptop (2.5Ghz, 4GB RAM, 500GB HD)",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/71qVOM%2BlgnL._AC_SL1500_.jpg",
    price: 399.99,
    rating: 5,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 13
  },
  {
    title:
      "DIERYA DK63 Wireless 60% Mechanical Gaming Keyboard True RGB Backlit Bluetooth 4.0 Wired LED Computer ",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/81hTAbyXjIL._SL1500_.jpg",
    price: 399.99,
    rating: 5,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 14
  },
  {
    title: "Converse Chuck Taylor All Star High Top Sneaker",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/6159zxGzaBL._AC_UX625_.jpg",
    price: 399.99,
    rating: 5,
    description: "Converse Chuck Taylor All Star High Top Sneaker",
    id: 15
  },
  {
    title:
      "HP Elite Desktop PC Computer Intel Core i5 3.1-GHz, 8 gb Ram, 1 TB Hard Drive, DVDRW, 19 Inch LCD Monitor, Keyboard, Mouse, Wireless WiFi, Windows 10Roadmaster - 26 Inches Granite Peak Men's Mountain Bike, Black/Blue",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/718sn7oOcfL._AC_SL1500_.jpg",
    price: 399.99,
    rating: 5,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 16
  },
  {
    title:
      "LEDKINGDOMUS Front Bumper Compatible with 07-18 Jeep Wrangler JK & Unlimited Rock Crawler Bumper with 4X LED Lights w/Winch Plate and D-rings",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/81SKxhRGjiL._AC_SL1500_.jpg",
    price: 399.99,
    rating: 5,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 17
  },
  {
    title: "Weruva Pumpkin Patch Up! Pumpkin Pouches for Dogs & Cats",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/71fLUJ4HSSL._AC_SL1500_.jpg",
    price: 399.99,
    rating: 5,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 18
  },
  {
    title:
      "Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's ",
    image: "https://m.media-amazon.com/images/I/91O9gt+QgsL._AC_UL320_.jpg",
    price: 399.99,
    rating: 5,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 19
  },
  {
    title: "Maxi-Cosi Pria 3-in-1 Convertible Car Seat, Blackened Pearl",
    image:
      "https://images-na.ssl-images-amazon.com/images/I/91gSfpJGZnL._SL1500_.jpg",
    price: 399.99,
    rating: 5,
    description:
      "What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has  is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book it has",
    id: 20
  }
];
